import {useRecoilValue} from 'recoil';
import {authState} from '../../../store/auth/atoms';
import {TypeAccountRoles} from '../../../shared/types/user-account.types';

export const useReportPermissions = () => {
  const {user} = useRecoilValue(authState);
  const roles = user?.roles || [];
  return {
    canView: roles.includes(TypeAccountRoles.VIEWER),
    canManage: roles.includes(TypeAccountRoles.MANAGER),
    canDownload: roles.includes(TypeAccountRoles.WORKER),
    companyId: user?.companyId,
  };
};
